import { axios } from '@Root/API'

export const remove = userId => {
	return axios.delete(`user/${userId}`)
}
